import { render } from "./replyBox.vue?vue&type=template&id=2e1a9e2b"
import script from "./replyBox.vue?vue&type=script&lang=js"
export * from "./replyBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__